// extracted by mini-css-extract-plugin
export var divider = "_mc-0";
export var systemMessage = "_mc-1";
export var systemMessageWrapper = "_mc-2";